<template>
  <div class="modal-mask">
    <div class="popup">
      <slot name="header"></slot>
      <slot name="body"></slot>
      <div class="confirm-btn">
        <slot name="confirm-yes"></slot>
        <slot name="confirm-no"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 12;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  -webkit-animation: fadein 0.5s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 0.5s; /* Firefox < 16 */
  -ms-animation: fadein 0.5s; /* Internet Explorer */
  -o-animation: fadein 0.5s; /* Opera < 12.1 */
  animation: fadein 0.5s;
  .popup {
    overflow-x: auto;
    overflow-y: auto;
    text-align: center;
    width: 100%;
    max-width: 322px;
    background-color: #fff;
    border-radius: 5px;
    margin: 0 auto;
    font-family: DBHeaventRez;
    position: absolute;
    top: calc(50% - 99.5px);
    left: calc(50% - 161px);
    h3 {
      color: #111111;
      text-align: center;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      font-size: 18px;
      font-weight: bold;
      padding-top: 36px;
    }
    .confirm-body {
      width: 100%;
      font-family: DBHeaventRez;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #949494;
      padding: 16px;
      margin: auto;
    }
    .confirm-btn {
      font-family: DBHeaventRez;
      font-size: 17px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      padding: 16px;
      .left {
        color: $color-orange;
        text-align: center;
        @include finCol(6, 12, 0px, middle, true, true);
      }
      .right {
        text-align: center;
        @include finCol(6, 12, 0px, middle, true, true);
      }
    }
  }
}

@keyframes hiding {
  to {
    width: 0;
    height: 0;
    overflow: hidden;
  }
}
@-webkit-keyframes hiding {
  to {
    width: 0;
    height: 0;
    visibility: hidden;
  }
}
</style>